"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmissionController = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _emittery = _interopRequireDefault(require("emittery"));
var _SubmissionValueProvider = require("./SubmissionValueProvider");
var _CachedContractsLoader = require("../controller/CachedContractsLoader");
class SubmissionController extends _emittery.default {
  constructor(submission) {
    super();
    (0, _defineProperty2.default)(this, "values", void 0);
    (0, _defineProperty2.default)(this, "dumbapp", null);
    (0, _defineProperty2.default)(this, "contractsLoader", new _CachedContractsLoader.CachedContractsLoader());
    (0, _defineProperty2.default)(this, "lastResolveResult", void 0);
    this.submission = submission;
    this.values = new _SubmissionValueProvider.SubmissionValueProvider(submission);
    this.dumbapp = submission === null || submission === void 0 ? void 0 : submission.dumbapp;
  }
  get lastResolve() {
    return this.lastResolveResult;
  }
  setApi(api) {
    this.contractsLoader.setApi(api);
  }
  setSubmission(submission) {
    if (submission) {
      this.dumbapp = submission.dumbapp;
      this.submission = submission;
      this.values.setSubmission(submission);
      this.trigger();
    }
  }
  placeholderText() {
    return "None";
  }
  trigger() {
    this.emit("change", this.values);
    this.doResolve();
  }
  submissionStep(index) {
    var _this$submission, _this$submission$data, _this$submission$data2;
    return (_this$submission = this.submission) === null || _this$submission === void 0 ? void 0 : (_this$submission$data = _this$submission.data) === null || _this$submission$data === void 0 ? void 0 : (_this$submission$data2 = _this$submission$data.steps) === null || _this$submission$data2 === void 0 ? void 0 : _this$submission$data2[index];
  }
  doResolve() {
    this.contractsLoader.handler({
      dumbapp: this.dumbapp
    }, this.submission.data.args).then(result => {
      if (result.success === true) {
        this.lastResolveResult = {
          success: true,
          arguments: this.submission.data.args.map((it, index) => {
            return {
              ...it,
              contract: result.data[index]
            };
          }),
          values: this.values,
          state: null
        };
        this.emit("resolve", this.lastResolveResult);
      } else {
        this.emit("resolve", result);
      }
    });
  }
}
exports.SubmissionController = SubmissionController;
//# sourceMappingURL=SubmissionController.js.map